import { InferType, boolean, object, string } from 'yup';

export const MixpanelCookieSchema = object({
  isLoggedIn: boolean().required(),
  deviceId: string().required(),
});
export type MixpanelCookieData = InferType<typeof MixpanelCookieSchema>;
